module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/010-slovenia-5640c8314aa8c9a092932039cfa77b4e.svg";